<template>
  <div class="card border-1">
    <div class="table-container">
      <table class="table create-billing table-width">
        <thead>
          <tr class="bg-black-light">
            <td class="font-medium-1 p-25" colspan="100%">{{ tableTitle }}</td>
          </tr>
          <tr class="text-center">
            <th>Item Description</th>
            <th>Type</th>
            <th>UoM</th>
            <th>Total Qty</th>
            <th>Total Mnf Cost</th>
            <th>Cost %</th>
            <th>Total Cost</th>
            <th>Per Unit Cost</th>
            <th v-if="itemType !== 'main_product'">Action</th>
          </tr>
        </thead>

        <tbody ref="tableRef">
            <ProductionComponentItem
                :total-cost="totalCost"
                v-for="(item, i) in tableItems"
                :key="i"
                :item="item"
                :index="i" 
                @onDeleteItem="onDeleteItem"
                @costPercentageCheck="costPercentageCheck"
                :isShowDeleteBtn="itemType !== 'main_product'"
                :itemType="itemType"
                v-show="showOrHideItems(item, i)"
                :costingProductTypes="costingProductTypes"
            />
            <tr>
              <td colspan="2">
                <button v-if="itemType !== 'main_product'" @click="addNewItem" class="btn btn-outline-primary btn-sm">
                  <i class="fas fa-plus"></i>
                  Add new
                </button>
              </td>
              <th colspan="3" class="text-center">Total</th>
              <th class="text-center">{{ getTotal }}</th>
              <th class="text-center"></th>
            </tr>
          </tbody>
      </table>
      <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from 'vue';
import ProductionComponentItem from "./ProductionComponentItem.vue";

const props = defineProps({
  tableTitle: {
    type: String
  },
  tableItems: {
    type: Array
  },
  type: {
    type: String,
    default: 'production'
  },
  itemType: {
    type: String,
  },
  totalCost: {
    type: [Number, String],
    default: 0
  },
  costingProductTypes: {
    type: Array,
    default: []
  }
})
const getTotal = computed(() => {
  return props.tableItems.reduce((total, amount) => total + parseFloat(amount.amount), 0).toFixed(4);
})

const showOrHideItems = (item, index) => {
  const { itemType } = props;

  if (itemType === 'main_product') {
    return item.product_type === 'main_product' || index === 0;
  }

  if (itemType === 'by_product') {
    return item.product_type !== 'main_product' && index !== 0;
  }

  return false;
}

const addNewItem = () => {
  props.tableItems.push({
    id: null,
    product: null,
    product_costingable_id: null,
    product_costingable_type: 'App\\Models\\Product',
    quantity: 1,
    wastage: 0,
    total_quantity: 1,
    rate: 0,
    amount: 0,
    type: props.type,
    product_type: 'by_product'
  })
}
const onDeleteItem = (index) => {
  props.tableItems.splice(index, 1);
  const otherItemsTotal = props.tableItems
      .filter((_, i) => i !== 0)
      .reduce((acc, item) => acc + item.wastage, 0);

  const remainingForFirstItem = 100 - otherItemsTotal;

  if (remainingForFirstItem >= 0) {
    return props.tableItems[0].wastage = remainingForFirstItem;
  }
  return props.tableItems[0].wastage = 0;
}

const costPercentageCheck = (index, costPercentage) => {
  props.tableItems[index].wastage = costPercentage;

  const otherItemsTotal = props.tableItems
      .filter((_, i) => i !== 0)
      .reduce((acc, item) => acc + item.wastage, 0);

  const remainingForFirstItem = 100 - otherItemsTotal;

  if (remainingForFirstItem >= 0) {
    return props.tableItems[0].wastage = remainingForFirstItem;
  }
  return props.tableItems[0].wastage = 0;
};

</script>

<style>
.create-billing > :not(first-child) > * {
  padding-left: 10px !important;
}

.create-billing > :not(caption) > * > * {
  padding: 0.72rem 0.2rem;
}

</style>
